import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "@/lib/utils"

const AVATAR_SIZE_CLASSES = {
 sm: 'size-[30px] text-[11px]',
 default: 'size-8 text-xs',
 lg: 'size-[38px] text-[13px]',
} as const

function Avatar({ className, size = 'default', ...props }: React.ComponentProps<typeof AvatarPrimitive.Root> & { size?: keyof typeof AVATAR_SIZE_CLASSES }) {
 return (
  <AvatarPrimitive.Root
   data-slot="avatar"
   className={cn('relative flex shrink-0 overflow-hidden rounded-full', AVATAR_SIZE_CLASSES[size], className)}
   {...props}
  />
 )
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
 return (
  <AvatarPrimitive.Image
   data-slot="avatar-image"
   className={cn('aspect-square size-full', className)}
   {...props}
  />
 )
}

function AvatarFallback({
 className,
 ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
 return (
  <AvatarPrimitive.Fallback
   data-slot="avatar-fallback"
   className={cn('flex size-full items-center justify-center rounded-full border border-border bg-accent font-semibold text-foreground', className)}
   {...props}
  />
 )
}

export { Avatar, AvatarImage, AvatarFallback }
